import { render, staticRenderFns } from "./wechatBindPhone.vue?vue&type=template&id=5ff399a7&scoped=true"
import script from "./wechatBindPhone.vue?vue&type=script&lang=js"
export * from "./wechatBindPhone.vue?vue&type=script&lang=js"
import style0 from "./wechatBindPhone.vue?vue&type=style&index=0&id=5ff399a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff399a7",
  null
  
)

export default component.exports